module.exports = __webpack_public_path__ + "0c3e47fd42f02195c404a8d58ec310be.svg";